<template>
    <header class="header">
        <div v-if="isTablet" class="header__mob">
            <button class="header__burger" type="button" @click="navbarMenuOpen = true">
                <svg class="header__burger-icon"><use href="#svg-icon-burger"></use></svg>
            </button>
			<router-link v-if="isTablet" class="header__logo" :to="{name: 'index'}">
				Avocado
			</router-link>
        </div>
        <div class="header__main">
			<div v-if="!isTablet" class="header__logo-wrap">
				<router-link class="header__logo" :to="{name: 'index'}">
					Avocado
				</router-link>
			</div>
			<teleport to="body" :disabled="!isTablet">
				<transition v-if="isTablet" name="fade">
					<div class="navbar__overlay" v-if="navbarMenuOpen" @click="navbarMenuOpen = false"></div>
				</transition>

				<div class="navbar" :class="{open: navbarMenuOpen}" ref="navbar">
					<div v-if="isTablet" class="navbar__header">
						<router-link :to="{name: 'index'}" class="header__logo">Avocado</router-link>
						<button class="navbar__close" type="button" @click="navbarMenuOpen = false">
							<svg class="navbar__close-icon"><use href="#svg-icon-close"></use></svg>
						</button>
					</div>
					<ul class="navbar__menu">
						<li class="navbar__menu-item" :class="[page === 'index' ? 'active': '']">
							<router-link :to="{name: 'index'}" class="navbar__menu-link">Главная</router-link>
						</li>
						<li class="navbar__menu-item" :class="[page === 'faq' ? 'active': '']">
							<router-link :to="{name: 'faq'}" class="navbar__menu-link">FAQ</router-link>
						</li>
						<li class="navbar__menu-item" :class="[page === 'revshare' ? 'active': '']">
							<a v-if="user === null" href="#" @click="handlerOpenSingIn"  class="navbar__menu-link">Рефералы</a>
							<router-link v-else :to="{name: 'revshare'}" class="navbar__menu-link">Рефералы</router-link>
						</li>
						<li class="navbar__menu-item" :class="[page === 'bonus' ? 'active': '']">
							<a v-if="user === null" href="#" @click="handlerOpenSingIn"  class="navbar__menu-link"> Бонусы</a>
							<router-link v-else :to="{name: 'bonus'}" class="navbar__menu-link">Бонусы</router-link>
						</li>
						<li class="navbar__menu-item" :class="[page === 'rang' ? 'active': '']">
							<router-link :to="{name: 'rang'}" class="navbar__menu-link">Ранги</router-link>
						</li>
						<li class="navbar__menu-item" :class="[page === 'settings' ? 'active': '']">
							<a v-if="user === null" href="#" @click="handlerOpenSingIn"  class="navbar__menu-link"> Настройки</a>
							<router-link v-else :to="{name: 'settings'}" class="navbar__menu-link">Настройки</router-link>
						</li>
						<li v-if="user !== null && isTablet" class="navbar__menu-item" :class="[page === 'history' ? 'active': '']">
							<router-link :to="{name: 'history'}" class="navbar__menu-link">Выплаты</router-link>
						</li>
						<li v-if="isTablet" class="navbar__menu-item" :class="[page === 'leaderboard' ? 'active': '']">
							<router-link :to="{name: 'leaderboard'}" class="navbar__menu-link">Топ игроков</router-link>
						</li>
						<li class="navbar__menu-item" :class="[page === 'contacts' ? 'active': '']">
							<router-link :to="{name: 'contacts'}" class="navbar__menu-link">Контакты</router-link>
						</li>
						<li class="navbar__menu-item">
							<a :href="$root.$link.reviews" target="_blank" class="navbar__menu-link">Отзывы</a>
						</li>
						<li class="navbar__menu-item">
							<router-link :to="{name: 'history'}" class="navbar__menu-link">Выплаты</router-link>
						</li>
						<li class="navbar__menu-item">
							<router-link :to="{name: 'leaderboard'}" class="navbar__menu-link">Топ игроков</router-link>
						</li>
						<li class="navbar__menu-item" v-if="user !== null && user.is_admin == 1" >
							<a class="navbar__menu-link" href="/admin" target="_blank">
								ПУ
							</a>
						</li>
					</ul>
					<div class="navbar__soc">
						<a :href="$root.$link.vk" class="navbar__soc-btn navbar__soc-btn--vk btn" target="_blank">
							<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-vk"></use></svg>
							<span v-if="isTablet" >Вконтакте</span>
						</a>
						<a :href="$root.$link.tg" class="navbar__soc-btn navbar__soc-btn--tg btn" target="_blank">
							<svg class="btn__icon" height="14" width="14"><use href="#svg-icon-tg"></use></svg>
							<span v-if="isTablet">Telegram</span>
						</a>
					</div>
            	</div>
			</teleport>
			<div class="header__actions header__actions--auth" v-if="user === null">
                <button class="header__action btn btn--white" @click="handlerOpenSingIn" type="button">
                    Вход
                </button>
                <button class="header__action btn btn--primary" @click="handlerOpenSingUp" type="button">
					Регистрация
				</button>
            </div>
            <div class="header__user" v-else>
				<router-link class="header__user-avatar" v-if="user.rang" :to="{name: 'rang'}">
					<img class="header__user-avatar-img" :src="user.rang.icon_url" />
				</router-link>
				<router-link class="header__user-info" :to="{name: 'settings'}">
					<div class="header__user-name">
						{{ user.username }}
					</div>
					<div v-show="!hideBalance" id="userBalance" mybalance="0" class="header__user-balance odometer odometer-auto-theme"></div>
					<div v-show="hideBalance" class="header__user-balance odometer odometer-auto-theme">
						В игре
					</div>
				</router-link>
            </div>
            <div class="header__actions" v-if="user !== null">
				<button class="header__action btn btn--primary" @click="openDepositModal" type="button">
					Пополнить
				</button>
                <router-link
                    :to="{'name': 'withdraw'}" 
                    class="header__action btn btn--white">
                    Вывод
                </router-link>
            </div>
        </div>
    </header>
</template>

<script>

	import { mapState } from 'pinia'
	import { useUserStore } from '../../stores/User'
	import BreakpointsMixin from "../../mixins/breakpoints-mixin.vue";
	import scrollLock from "scroll-lock";

    export default {

		mixins: [
			BreakpointsMixin
		],

        data() {
            return {
                currentPage: null,
				navbarMenuOpen: false
            }
        },

		watch: {
			navbarMenuOpen(state) {
				if (state) {
					scrollLock.disablePageScroll(this.$refs.navbar);
				} else {
					setTimeout(() => {
						scrollLock.enablePageScroll(this.$refs.navbar);
					}, 300);
				}
			},

			'$route.path'(newValue, oldValue) {
				if(newValue !== oldValue && this.navbarMenuOpen) {
					this.navbarMenuOpen = false
				}
			}
		},

		computed: {
			...mapState(useUserStore, ['user']),

			page() {
				return this.$route.name;
			},

			hideBalance() {
				return ['slotsGame'].includes(this.$route.name);
			},
		},

		methods: {
			handlerOpenSingIn() {
				this.$root.emitter.emit('showModalSignIn')
			},

			handlerOpenSingUp() {
				this.$root.emitter.emit('showModalSignUp')
			},

			openDepositModal() {
				this.$root.emitter.emit('openDepositModal')
			}
		}
    }
</script>
